import {
  PRICING_BUSINESS_RATE_COLUMNS_WITH_RATES,
  PRICING_BUSINESS_RATE_COLUMNS_WITH_SPREAD,
} from './feature-columns/pricing/business-rate';
import {
  PRICING_RULE_SET_CLASSIFICATION_COLUMNS,
  PRICING_RULE_SET_COLUMNS_WITHOUT_CLASSIFICATION,
} from './feature-columns/pricing/rule-set';
import {
  COMMISSION_RULE_COLUMNS_WITHOUT_CURRENCY,
  COMMISSION_RULE_COLUMNS_WITH_CURRENCY,
} from './feature-columns/pricing/commission-rule';
import {
  MONTHLY_PRICING_RANGE_COLUMNS_WITH_SEGMENT,
  MONTHLY_PRICING_RANGE_COLUMNS_WITH_CURRENCY,
  DEFAULT_PRICING_RANGE_COLUMNS_WITHOUT_CURRENCY,
  DEFAULT_PRICING_RANGE_COLUMNS_WITH_CURRENCY,
} from './feature-columns/pricing/pricing-range';

export const PRICING_PLATFORM_FEATURES = {
  MONTHLY_PRICING_RANGES_VISIBLE_COLUMNS: 'pricing.monthlyRanges.visibleColumns',
  DEFAULT_PRICING_RANGES_VISIBLE_COLUMNS: 'pricing.defaultRanges.visibleColumns',
  PRICING_RULE_SETS_VISIBLE_COLUMNS: 'pricing.ruleSets.visibleColumns',
  PRICING_BUSINESS_RATES_VISIBLE_COLUMNS: 'pricing.businessRates.visibleColumns',
  COMMISSION_RULES_VISIBLE_COLUMNS: 'pricing.commissionRules.visibleColumns',
};

export const PRICING_PLATFORM_FEATURE_CONFIG = {
  BCH: {
    [PRICING_PLATFORM_FEATURES.MONTHLY_PRICING_RANGES_VISIBLE_COLUMNS]:
      MONTHLY_PRICING_RANGE_COLUMNS_WITH_SEGMENT,
    [PRICING_PLATFORM_FEATURES.DEFAULT_PRICING_RANGES_VISIBLE_COLUMNS]:
      DEFAULT_PRICING_RANGE_COLUMNS_WITHOUT_CURRENCY,
    [PRICING_PLATFORM_FEATURES.PRICING_RULE_SETS_VISIBLE_COLUMNS]:
      PRICING_RULE_SET_COLUMNS_WITHOUT_CLASSIFICATION,
    [PRICING_PLATFORM_FEATURES.PRICING_BUSINESS_RATES_VISIBLE_COLUMNS]:
      PRICING_BUSINESS_RATE_COLUMNS_WITH_RATES,
    [PRICING_PLATFORM_FEATURES.COMMISSION_RULES_VISIBLE_COLUMNS]:
      COMMISSION_RULE_COLUMNS_WITHOUT_CURRENCY,
  },
  SANTANDER: {
    [PRICING_PLATFORM_FEATURES.MONTHLY_PRICING_RANGES_VISIBLE_COLUMNS]:
      MONTHLY_PRICING_RANGE_COLUMNS_WITH_SEGMENT,
    [PRICING_PLATFORM_FEATURES.DEFAULT_PRICING_RANGES_VISIBLE_COLUMNS]:
      DEFAULT_PRICING_RANGE_COLUMNS_WITHOUT_CURRENCY,
    [PRICING_PLATFORM_FEATURES.PRICING_RULE_SETS_VISIBLE_COLUMNS]:
      PRICING_RULE_SET_COLUMNS_WITHOUT_CLASSIFICATION,
    [PRICING_PLATFORM_FEATURES.PRICING_BUSINESS_RATES_VISIBLE_COLUMNS]:
      PRICING_BUSINESS_RATE_COLUMNS_WITH_RATES,
    [PRICING_PLATFORM_FEATURES.COMMISSION_RULES_VISIBLE_COLUMNS]:
      COMMISSION_RULE_COLUMNS_WITHOUT_CURRENCY,
  },
  FINGO: {
    [PRICING_PLATFORM_FEATURES.MONTHLY_PRICING_RANGES_VISIBLE_COLUMNS]:
      MONTHLY_PRICING_RANGE_COLUMNS_WITH_SEGMENT,
    [PRICING_PLATFORM_FEATURES.DEFAULT_PRICING_RANGES_VISIBLE_COLUMNS]:
      DEFAULT_PRICING_RANGE_COLUMNS_WITHOUT_CURRENCY,
    [PRICING_PLATFORM_FEATURES.PRICING_RULE_SETS_VISIBLE_COLUMNS]:
      PRICING_RULE_SET_COLUMNS_WITHOUT_CLASSIFICATION,
    [PRICING_PLATFORM_FEATURES.PRICING_BUSINESS_RATES_VISIBLE_COLUMNS]:
      PRICING_BUSINESS_RATE_COLUMNS_WITH_RATES,
    [PRICING_PLATFORM_FEATURES.COMMISSION_RULES_VISIBLE_COLUMNS]:
      COMMISSION_RULE_COLUMNS_WITHOUT_CURRENCY,
  },
  ITAU: {
    [PRICING_PLATFORM_FEATURES.MONTHLY_PRICING_RANGES_VISIBLE_COLUMNS]:
      MONTHLY_PRICING_RANGE_COLUMNS_WITH_CURRENCY,
    [PRICING_PLATFORM_FEATURES.DEFAULT_PRICING_RANGES_VISIBLE_COLUMNS]:
      DEFAULT_PRICING_RANGE_COLUMNS_WITH_CURRENCY,
    [PRICING_PLATFORM_FEATURES.PRICING_RULE_SETS_VISIBLE_COLUMNS]:
      PRICING_RULE_SET_CLASSIFICATION_COLUMNS,
    [PRICING_PLATFORM_FEATURES.PRICING_BUSINESS_RATES_VISIBLE_COLUMNS]:
      PRICING_BUSINESS_RATE_COLUMNS_WITH_SPREAD,
    [PRICING_PLATFORM_FEATURES.COMMISSION_RULES_VISIBLE_COLUMNS]:
      COMMISSION_RULE_COLUMNS_WITH_CURRENCY,
  },
};
